import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useFormState } from 'react-use-form-state'
import { toast } from 'react-toastify'
import capitalize from '../../common/formatters/capitalize'

import Input from '../input'
import ExistsValidator from '../../common/validators/exists'

const EntityEditor = ({ updateItem, item, items, entityName, entityLabel }) => {
  const [formState, { text }] = useFormState({ ...item, items, initialValue: item.name })

  if (items !== formState.values.items) {
    formState.setField('items', items)
  }

  const onUpdate = useCallback(
    event => {
      event && event.preventDefault()
      if (!formState.errors.name && formState.values.name.trim()) {
        updateItem(item.id, formState.values.name.trim()).then(() => {
          toast.success(`${capitalize(entityLabel || entityName)} '${formState.values.initialValue}' updated to '${formState.values.name}'`, {
            position: toast.POSITION.TOP_RIGHT,
          })
          formState.setField('initialValue', formState.values.name)
        })
      }
      return false
    },
    [formState, updateItem, item.id, entityLabel, entityName],
  )


  return  (
    <form onSubmit={onUpdate} autoComplete="off">
      <Input {...{
        name: 'name',
        text,
        error: formState.errors.name,
        validate: ExistsValidator,
        validateOnBlur: false,
        onSave: formState.values.name !== formState.values.initialValue ? onUpdate : null,
        inverted: true,
      }}/>
    </form>
  )
}

EntityEditor.propTypes = {
  items: PropTypes.array,
  item: PropTypes.object,
  loading: PropTypes.bool,
  updateItem: PropTypes.func,
}

export default EntityEditor
